// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gbUst2V9quKVMm8qpbjt{position:relative;padding:3px 22px 3px 3px}.gbUst2V9quKVMm8qpbjt .UuwiljAEaYP8dxvZxP2v{margin:22px 0 18px}`, "",{"version":3,"sources":["webpack://./src/pages/contacts/pages/cleanup/ui/ContactsUnlinkedTable/ui/LinkContact/ui/LinkContactModalContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,wBAAA,CAEA,4CACE,kBAAA","sourcesContent":[".wrap {\n  position: relative;\n  padding: 3px 22px 3px 3px;\n\n  .tabs {\n    margin: 22px 0 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `gbUst2V9quKVMm8qpbjt`,
	"tabs": `UuwiljAEaYP8dxvZxP2v`
};
export default ___CSS_LOADER_EXPORT___;
